export default {
  setConnection(state, connection) {
    state.connection = connection;
    state.syncRun = connection?.syncRun ?? null;
  },
  setSyncRun(state, syncRun) {
    state.syncRun = syncRun;
  },
  setRuns(state, runs) {
    state.runs = runs;
  },
  setIssues(state, issues) {
    state.issues = issues;
  },
  clear(state) {
    state.connection = null;
    state.syncRun = null;
    state.runs = [];
    state.issues = [];
  }
};
